import { Tab, TabTypename } from "autoGenSubTypes";
import { DashboardTabType } from "gql/apollo/graphql";

/**
 * This function takes a dashboard tab object and returns the path to get to it
 *
 * @param tab
 * @returns string (path to the tab used as an arg)
 */
export const getTabPath = (tab: Tab) => {
	let path = "";

	switch (tab.__typename) {
		case "AlertsTab": {
			path = `alerts/${tab.key}`;
			break;
		}
		case "ColumnsTab": {
			path = `columns/${tab.key}`;
			break;
		}
		case "SettingsTab": {
			path = "settings";
			break;
		}
		case "StreamManagerTab": {
			path = "streams";
			break;
		}
		case "IncidentTab": {
			path = `incident/${tab.incident_tab_data.incident_id}`;
			break;
		}
		case "DarkWebTab": {
			path = `darkweb/${tab.dark_web_tab_data.dark_web_post_id}`;
			break;
		}
	}

	return path;
};

export const tabTypeIndex: { [key in DashboardTabType]?: TabTypename } = {
	ALERTS: "AlertsTab",
	DARK_WEB: "DarkWebTab",
	HISTORICAL_SEARCH: "HistoricalSearchTab",
	INCIDENT: "IncidentTab",
	SEARCH: "HistoricalSearchTab", // SearchTab does not exist yet (v2)
	SETTINGS: "SettingsTab",
	STREAM_MANAGER: "StreamManagerTab",
	TRACKED_EVENT: "IncidentTab", // TrackedEventTab does not exist
};
